export default __webpack_public_path__ + "556a9c0b2f5757ed87b49af2626e6bf5.svg";